import { FC, useState } from "react";
import { LineStylePopup } from "shared/ui";
import type { AlligatorSettings, AlligatorLineStyle } from "../../model";
import styles from "./ADXStylesTab.module.css";

type LineKey = "jaws" | "teeth" | "lips";

const LINES: { key: LineKey; label: string }[] = [
  { key: "jaws", label: "jaws" },
  { key: "teeth", label: "teeth" },
  { key: "lips", label: "lips" },
];

interface Props {
  settings: AlligatorSettings;
  onChange: (s: AlligatorSettings) => void;
}

export const AlligatorStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [openPopup, setOpenPopup] = useState<LineKey | null>(null);

  const toggle = (key: LineKey) =>
    setOpenPopup((prev) => (prev === key ? null : key));

  const updateLine = (key: LineKey, patch: Partial<AlligatorLineStyle>) =>
    onChange({ ...settings, [key]: { ...settings[key], ...patch } });

  return (
    <div className={styles.tab}>
      {LINES.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <div className={styles.left}>
            <label className={styles.checkboxWrap}>
              <input
                type="checkbox"
                className={styles.checkboxInput}
                checked={settings[key].visible}
                onChange={(e) => updateLine(key, { visible: e.target.checked })}
              />
              <span className={styles.checkmark} />
            </label>
            <span className={styles.label}>{label}</span>
          </div>
          <div className={styles.btnWrap}>
            <button
              className={styles.colorBtn}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={() => toggle(key)}
            >
              <span
                className={styles.colorBtnSwatch}
                style={{ background: settings[key].color }}
              />
              <span className={styles.colorBtnWidth}>
                {settings[key].width}px
              </span>
            </button>
            {openPopup === key && (
              <LineStylePopup
                color={settings[key].color}
                width={settings[key].width}
                onColorChange={(c) => updateLine(key, { color: c })}
                onWidthChange={(w) => updateLine(key, { width: w })}
                onClose={() => setOpenPopup(null)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
